import styles from './no-results.module.css';

export function NoResults({ text }: { text: string }) {
    return (
        <div className={styles['no-results']}>
            <p className={styles['no-results__text']}>{text}</p>
        </div>
    );
}
